import { NavLink, Outlet } from "react-router-dom";
import { ChartBar, Books, Package, Tag, Gear, ArrowSquareOut, Feather, Star } from "@phosphor-icons/react";

const links = [
  { to: "/admin", label: "Overview", icon: ChartBar, end: true },
  { to: "/admin/orders", label: "Orders", icon: Package },
  { to: "/admin/books", label: "Titles", icon: Books },
  { to: "/admin/poems", label: "Poems", icon: Feather },
  { to: "/admin/reviews", label: "Reviews", icon: Star },
  { to: "/admin/coupons", label: "Coupons", icon: Tag },
  { to: "/admin/settings", label: "Settings", icon: Gear },
];

export default function AdminLayout() {
  return (
    <div className="mx-auto flex max-w-7xl gap-8 px-5 py-8 sm:px-8" data-testid="admin-layout">
      <aside className="hidden w-52 shrink-0 md:block">
        <p className="eyebrow mb-4 px-3">Admin</p>
        <nav className="space-y-1">
          {links.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${isActive ? "bg-foreground text-white" : "text-foreground/75 hover:bg-muted"}`}>
              <Icon weight="duotone" size={18} /> {label}
            </NavLink>
          ))}
          <NavLink to="/" className="flex items-center gap-2.5 rounded-md px-3 py-2 text-sm text-muted-foreground hover:bg-muted" data-testid="admin-nav-storefront"><ArrowSquareOut size={18} /> View storefront</NavLink>
        </nav>
      </aside>
      <div className="min-w-0 flex-1">
        <nav className="mb-6 flex gap-2 overflow-x-auto md:hidden">
          {links.map(({ to, label, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold ${isActive ? "bg-foreground text-white" : "bg-muted"}`}>{label}</NavLink>
          ))}
        </nav>
        <Outlet />
      </div>
    </div>
  );
}

export const AdminCard = ({ title, children, className = "", action }) => (
  <section className={`rounded-lg border border-border bg-white ${className}`}>
    {(title || action) && <div className="flex items-center justify-between border-b border-border px-4 py-3"><h2 className="text-sm font-semibold">{title}</h2>{action}</div>}
    <div className="p-4">{children}</div>
  </section>
);

export const adminInput = "h-9 w-full rounded-md border border-input bg-white px-3 text-sm outline-none ring-primary focus:ring-2";
export const adminBtn = "inline-flex h-9 items-center gap-1.5 rounded-md bg-foreground px-4 text-sm font-semibold text-white transition-colors hover:bg-foreground/85 disabled:opacity-50";
export const adminBtnGhost = "inline-flex h-9 items-center gap-1.5 rounded-md border border-border bg-white px-3 text-sm font-medium hover:bg-muted disabled:opacity-50";
